import React, { useState, useEffect } from 'react';
import {
  Card,
  TextField,
  Divider,
  MenuItem,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  Checkbox,
  Button,
  Grid,
} from '@mui/material';
import { countries } from '../ecommerce/Country';
import { Box, styled } from '@mui/system';
import { Paragraph } from 'app/components/Typography';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { Breadcrumb } from 'app/components';
import { useSelector } from 'react-redux';
import axios from 'axios';

const StyledCard = styled(Card)(({ theme }) => ({
  margin: '0px',
  padding: '24px',
  [theme.breakpoints.down('sm')]: {
    margin: '16px',
  },
}));

const Container = styled('div')(({ theme }) => ({
  margin: '0px',
  [theme.breakpoints.down('sm')]: {
    margin: '16px',
  },
  '& .breadcrumb': {
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '16px',
    },
  },
}));

const InputField = styled(TextField)(() => ({
  marginBottom: '16px',
}));

const PersonalInformation = () => {
  // src/app/views/forms/PropertyListingForm.jsx
  const [date, setDate] = useState(new Date());
  // const [firstName, setFirstName] = useState('');
  // const [lastName, setLastName] = useState('');
  // const [presentAddress, setPresentAddress] = useState('');
  const [inputText, setInputText] = useState({
    firstName: '',
    lastName: '',
    presentAddress: '',
  });

  const onChange = (e) => {
    setInputText({
      ...inputText,
      [e.target.name]: e.target.value,
    });
  };

  // const onChangeFirstName = (e) => {
  //   setFirstName(e.target.value);
  // };

  const { user: currentUser } = useSelector((state) => state.auth);

  const getEmployee = async () => {
    console.log('getEmployee', currentUser.username);
    try {
      // setErrorMessage('');
      const { data } = await axios.get('/api/cis/employee', {
        params: { employeeId: currentUser.username },
      });
      const [{ firstName, lastName, presentAddress }] = data;

      console.log('getEmployee --> ', firstName);
      setInputText({
        ['firstName']: firstName,
        ['lastName']: lastName,
        ['presentAddress']: presentAddress,
      });
      // setInputText({ ...inputText, ['firstName']: firstName });
      // setInputText({ ...inputText, ['lastName']: firstName });
      // setInputText({ ...inputText, [firstName]: firstName });
      // setInputText({ ...inputText, lastName: lastName });
      // setInputText({ ...inputText, presentAddress: presentAddress });
      // setFirstName(firstName);
      // setLastName(inputText.lastName);
      // setPresentAddress(inputText.presentAddress);
      //
    } catch (error) {
      // setIsLoading(false);
      // setErrorMessage(
      //   error.response
      //     ? error.response.data.message || 'เกิดข้อผิดพลาดบางอย่าง'
      //     : 'เกิดข้อผิดพลาดบางอย่าง'
      // );
      console.log(error.response);
    }
  };

  useEffect(() => {
    getEmployee();
  }, []);

  return (
    <Container>
      <div className="breadcrumb">
        <Breadcrumb
          routeSegments={[
            { name: 'Pages', path: '/pages' },
            { name: 'ข้อมูลประวัติส่วนตัว' },
          ]}
        />
      </div>
      <StyledCard>
        <Box mx="auto" maxWidth={600}>
          <h4>ข้อมูลประวัติส่วนตัว {currentUser.username}</h4>
          {/* <p>Please fill the form below to know more about the property</p> */}
          <Divider sx={{ mb: 4 }} />

          <Box mb={2} display="flex">
            <TextField
              sx={{ mr: 1 }}
              label="ชื่อ"
              variant="outlined"
              size="small"
              name="firstName"
              value={inputText.firstName}
              onChange={onChange}
              fullWidth
            />
            <TextField
              sx={{ ml: 1 }}
              label="นามสกุล"
              variant="outlined"
              size="small"
              name="lastName"
              value={inputText.lastName}
              onChange={onChange}
              fullWidth
            />
          </Box>

          <InputField
            label="ภูมิลำเนา"
            variant="outlined"
            size="small"
            name="presentAddress"
            value={inputText.presentAddress}
            onChange={onChange}
            fullWidth
          />

          <Box display="flex" justifyContent="center">
            <Button sx={{ px: '28px' }} variant="contained" color="primary">
              Submit
            </Button>
          </Box>
        </Box>
      </StyledCard>
    </Container>
  );
};

const stayDurationList = [
  'Less than a week',
  'One week',
  'One month',
  "I'm not sure",
];

const propertyTypeList = [
  'Row Land',
  'Lot in a Development',
  'Condos',
  'Single Family Home',
  'Other',
];

const locationTypeList = [
  'Ocean View',
  'Beach Front',
  'Near Surf',
  'In Town',
  'Farm',
  'Other',
  "Doesn't Matter",
];

const budgetList = [
  '$0 - $50,000',
  '$50,000 - $100,000',
  '$100,000 - $500,000',
  '$500,000 - $1,000,000',
  '$1,000,000 Plus',
];
export default PersonalInformation;
